// extracted by mini-css-extract-plugin
module.exports = {"reportForm":"style__reportForm__Cfuhk","shapeReport":"style__shapeReport__F3mcq"};